"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStaticConditionController = void 0;
const utilsConditions_1 = require("./utilsConditions");
// This is a static condition controller. It checks against a static value, not a dynamic one.
// e.g.: rule::Q_BI_Limit_per_person::lessThanOrEqual::50000
const createStaticConditionController = (rules) => {
    const handlers = rules.map(rule => (0, utilsConditions_1.createGenericRule)(rule));
    return (getValue) => {
        const hideValue = handlers.some((handler) => !handler.op((0, utilsConditions_1.numberIfNumberlike)(getValue(handler.affectingQuestionId)), handler.comparable));
        return hideValue;
    };
};
exports.createStaticConditionController = createStaticConditionController;
